import * as React from "react";
import classnames from "classnames";
import { connect } from "react-redux";
import { RootState, AppLocale } from "../redux/types";
import { Provider, FormattedMessage } from "@oursky/react-messageformat";
import NumberFormat from 'react-number-format';
import styles from "./Offer.module.scss";
import { mainSite } from "../config";
import { Wine } from "../types";

interface Props {
  taglineTranslation: {
    [key: string]: string | undefined;
  };
  imageUrl: string;
  wineNameTranslation: {
    [key: string]: string | undefined;
  };
  vintage: string;
  quantityPerCase: number;
  marketPrice: number;
  price: number;
  locale: AppLocale;
  wine: Wine;
  offerId: number;
  soldout: boolean;
}

class Offer extends React.PureComponent<Props> {
  render() {
    const {
      locale,
      taglineTranslation,
      wineNameTranslation,
      imageUrl,
      vintage,
      quantityPerCase,
      marketPrice,
      price,
      wine,
      offerId,
      soldout,
    } = this.props;

    return (
      <div className={styles.container}>
        <div className={styles.taglineContainer}>
          <Provider locale={locale} messageByID={taglineTranslation}>
            <h6 className={styles.tagline}>
              <FormattedMessage id={locale} />
            </h6>
          </Provider>
        </div>
        <div className={styles.body}>
          <img
            src={imageUrl}
            className={styles.image}
          />
          <Provider locale={locale} messageByID={wineNameTranslation}>
            <div className={styles.wineNameContainer}>
              <h3 className={styles.wineName}>
                <FormattedMessage
                   id={locale}
                /> {vintage}
              </h3>
            </div>
          </Provider>
          <p className={styles.marketPrice}>
            <FormattedMessage
              id="OFFER.MarketPriceLabel"
              values={{
                priceLabel: <FormattedMessage
                  id="OFFER.Price"
                  values={{
                    price: <NumberFormat
                      thousandSeparator={true}
                      displayType="text"
                      value={marketPrice / quantityPerCase}
                      decimalScale={0}
                    />,
                  }}
                />
              }}
            />
          </p>
          <p className={styles.price}>
            <FormattedMessage
              id="OFFER.Price"
              values={{
                price: <b><NumberFormat
                  thousandSeparator={true}
                  displayType="text"
                  value={price / quantityPerCase}
                  decimalScale={0}
                /></b>,
              }}
            />
          </p>
          <p className={styles.text}>
            <FormattedMessage
              id="OFFER.Info"
              values={{
                quantityPerCase,
                price: <NumberFormat
                  thousandSeparator={true}
                  displayType="text"
                  value={price}
                  decimalScale={0}
                />
              }}
            />
          </p>
        </div>
        {soldout ? <div className={classnames(styles.buyButton, styles.buyButtonSold)}>
          <FormattedMessage id="OFFER.Sold" />
        </div> : <a href={`//${mainSite}/place-order/${wine.wine_info.slug}/${wine.vintage}/${wine.packing_size}?offerId=${offerId}&unauth=signup`} target="_blank">
          <div className={styles.buyButton}>
            <FormattedMessage id="OFFER.Buy" />
          </div>
        </a>}
      </div>
    );
  }
}

function mapStateToProps(state: RootState) {
  return {
    locale: state.app.locale,
  };
}

export default connect(mapStateToProps)(Offer);



// WEBPACK FOOTER //
// ./src/components/Offer.tsx